import { DetailDataProvider } from './DetailDataProvider'
import DetailViewContainer from './DetailViewContainer'

export default DetailViewWrapper = (props) ->
  <DetailDataProvider>
    <DetailViewContainer {props...} />
  </DetailDataProvider>